export default __webpack_public_path__ + "static/media/JoshuaCross_ResumePortfolio.61f3354a.pdf";